import React, { useState } from 'react';
import ProjectTitleInput from '../Common/ProjectTitleInput';
import './Onboarding.css';

/**
 * Basic info form for architect path.
 * Gathers title, pitch, and series question (novels only).
 */
function BasicInfoForm({ medium, onSubmit }) {
  const [title, setTitle] = useState('');
  const [pitch, setPitch] = useState('');
  const [seriesChoice, setSeriesChoice] = useState(null); // null | 'standalone' | 'series' | 'unsure'

  const isNovel = medium === 'novel';
  const mediumLabel = 'novel';

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({
      title: title.trim() || 'Untitled',
      pitch: pitch.trim(),
      isSeries: seriesChoice === 'series',
      medium
    });
  };

  // Require pitch and series choice for novels
  const isValid = pitch.trim().length > 0 && (!isNovel || seriesChoice !== null);

  return (
    <form className="basic-info-form" onSubmit={handleSubmit}>
      <h2 className="basic-info-form__heading">
        Let's capture your vision.
      </h2>

      <div className="basic-info-form__field">
        <label className="basic-info-form__label" htmlFor="title">
          Working title:
        </label>
        <ProjectTitleInput
          id="title"
          className="basic-info-form__input"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder={
            isNovel
              ? "The Lighthouse Keeper's Daughter"
              : 'The Lighthouse'
          }
        />
      </div>

      <div className="basic-info-form__field">
        <label className="basic-info-form__label" htmlFor="pitch">
          {isNovel ? 'Quick pitch (1-2 sentences):' : 'Logline:'}
        </label>
        <textarea
          id="pitch"
          className="basic-info-form__textarea"
          value={pitch}
          onChange={(e) => setPitch(e.target.value)}
          placeholder={
            isNovel
              ? 'A marine biologist returns to her hometown when her estranged father dies, only to discover the lighthouse holds secrets that could unravel her understanding of her own past.'
              : 'A disgraced marine biologist must confront her past when she inherits a mysterious lighthouse that holds the key to a decades-old disappearance.'
          }
          rows={3}
          required
        />
      </div>

      {isNovel && (
        <div className="basic-info-form__field">
          <label className="basic-info-form__label">
            Is this a standalone {mediumLabel} or part of a series?
          </label>
          <div className="basic-info-form__radio-group">
            <label className="basic-info-form__radio-label">
              <input
                type="radio"
                name="series"
                value="standalone"
                checked={seriesChoice === 'standalone'}
                onChange={() => setSeriesChoice('standalone')}
              />
              Standalone
            </label>
            <label className="basic-info-form__radio-label">
              <input
                type="radio"
                name="series"
                value="series"
                checked={seriesChoice === 'series'}
                onChange={() => setSeriesChoice('series')}
              />
              Part of a series
            </label>
            <label className="basic-info-form__radio-label">
              <input
                type="radio"
                name="series"
                value="unsure"
                checked={seriesChoice === 'unsure'}
                onChange={() => setSeriesChoice('unsure')}
              />
              Not sure yet
            </label>
          </div>
        </div>
      )}

      <button
        type="submit"
        className="basic-info-form__button"
        disabled={!isValid}
      >
        Continue
      </button>
    </form>
  );
}

export default BasicInfoForm;
